import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "border-b border-[rgba(227,233,243,0.95)] px-6 py-5" }
const _hoisted_2 = { class: "grid gap-4 md:grid-cols-2" }
const _hoisted_3 = { class: "space-y-2 md:col-span-2" }
const _hoisted_4 = ["value"]
const _hoisted_5 = {
  key: 1,
  class: "rounded-[0.95rem] border border-[rgba(211,220,233,1)] bg-[#f8fbff] px-3 py-3 text-sm text-[#243049]"
}
const _hoisted_6 = { class: "space-y-2" }
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "space-y-2" }
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "space-y-2" }
const _hoisted_11 = { class: "space-y-2" }
const _hoisted_12 = { class: "rounded-[1.15rem] border border-[rgba(211,220,233,1)] bg-[#f8fbff] p-4" }
const _hoisted_13 = { class: "flex items-start justify-between gap-3" }
const _hoisted_14 = { class: "flex items-center gap-2 text-sm font-semibold text-[#243049]" }
const _hoisted_15 = { class: "mt-4" }
const _hoisted_16 = {
  key: 0,
  class: "mt-3 space-y-2"
}
const _hoisted_17 = { class: "truncate text-[#243049]" }
const _hoisted_18 = { class: "whitespace-nowrap text-xs font-semibold text-[#6e7b92]" }
const _hoisted_19 = {
  key: 1,
  class: "mt-3 rounded-[0.9rem] border border-dashed border-[rgba(216,228,240,0.95)] bg-white px-3 py-3 text-sm text-[#6e7b92]"
}
const _hoisted_20 = { class: "grid gap-3 md:grid-cols-3" }
const _hoisted_21 = { class: "rounded-[1rem] border border-[rgba(216,228,240,0.95)] bg-white px-4 py-3" }
const _hoisted_22 = { class: "mt-1 text-sm font-semibold text-[#243049]" }
const _hoisted_23 = { class: "rounded-[1rem] border border-[rgba(216,228,240,0.95)] bg-white px-4 py-3" }
const _hoisted_24 = { class: "mt-1 text-sm font-semibold text-[#243049]" }
const _hoisted_25 = { class: "rounded-[1rem] border border-[rgba(216,228,240,0.95)] bg-white px-4 py-3" }
const _hoisted_26 = { class: "mt-1 text-sm font-semibold text-[#243049]" }
const _hoisted_27 = {
  key: 0,
  class: "rounded-[1rem] border border-[#f5c2c7] bg-[#fff5f5] px-4 py-3 text-sm text-[#b42318]"
}

import { computed, reactive, ref, watch } from "vue";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import type { DashboardClientOption, DashboardFilters, DashboardReportRequest, DashboardRole } from "@/types/dashboard";


export default /*@__PURE__*/_defineComponent({
  __name: 'GenerateReportModal',
  props: {
    open: { type: Boolean },
    loading: { type: Boolean },
    error: {},
    role: {},
    filters: {},
    clients: {},
    serviceOptions: {},
    packageOptions: {}
  },
  emits: ["update:open", "generate"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const dialogOpen = computed({
  get: () => props.open,
  set: (value: boolean) => emit("update:open", value),
});

const form = reactive<DashboardReportRequest>({
  client_id: "all",
  service_id: null,
  package_id: null,
  date_from: null,
  date_to: null,
  include_appendix: true,
  supporting_resources: [],
});

const selectedFiles = ref<File[]>([]);
const mode = ref<"html" | "pdf">("html");

const canFilterByClient = computed(() => props.role !== "client");
const currentClientLabel = computed(() => {
  const match = props.clients.find((client) => client.client_id === props.filters.client_id);
  return match?.company_name ?? "Current client";
});
const summaryClient = computed(() => {
  if (!canFilterByClient.value) {
    return currentClientLabel.value;
  }

  if (form.client_id === "all") {
    return "All clients";
  }

  return props.clients.find((client) => client.client_id === form.client_id)?.company_name ?? "Selected client";
});

const packageValue = computed({
  get: () => (form.package_id === null ? "" : String(form.package_id)),
  set: (value: string) => {
    form.package_id = value === "" ? null : Number(value);
  },
});

const serviceValue = computed({
  get: () => (form.service_id === null ? "" : String(form.service_id)),
  set: (value: string) => {
    form.service_id = value === "" ? null : Number(value);
  },
});

const summaryRange = computed(() => {
  const from = form.date_from ?? "Start";
  const to = form.date_to ?? "Now";
  return `${from} to ${to}`;
});

function resetFromFilters() {
  form.client_id = props.filters.client_id || "all";
  form.service_id = props.filters.service_id;
  form.package_id = props.filters.package_id;
  form.date_from = props.filters.date_from;
  form.date_to = props.filters.date_to;
  form.include_appendix = true;
  form.supporting_resources = [];
  selectedFiles.value = [];
}

function handleFiles(event: Event) {
  const input = event.target as HTMLInputElement;
  selectedFiles.value = Array.from(input.files ?? []);
}

function submit() {
  emit("generate", {
    client_id: form.client_id,
    service_id: form.service_id,
    package_id: form.package_id,
    date_from: form.date_from,
    date_to: form.date_to,
    include_appendix: form.include_appendix,
    supporting_resources: selectedFiles.value,
    mode: mode.value,
  });
}

function close() {
  emit("update:open", false);
}

function formatSize(size: number) {
  if (size < 1024) return `${size} B`;
  if (size < 1024 * 1024) return `${Math.round(size / 1024)} KB`;
  return `${(size / (1024 * 1024)).toFixed(1)} MB`;
}

watch(
  () => props.open,
  (isOpen) => {
    if (isOpen) {
      resetFromFilters();
      mode.value = "html";
    }
  },
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Dialog), {
    open: dialogOpen.value,
    "onUpdate:open": _cache[8] || (_cache[8] = ($event: any) => ((dialogOpen).value = $event))
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(DialogContent), { class: "max-h-[92vh] max-w-[44rem] overflow-y-auto rounded-[1.4rem] border border-[rgba(215,226,239,0.95)] bg-white p-0 shadow-[0_24px_60px_rgba(15,23,42,0.22)]" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_unref(DialogHeader), { class: "gap-y-2 text-left" }, {
              default: _withCtx(() => [
                _createVNode(_unref(DialogTitle), { class: "text-[1.3rem] font-extrabold text-[#182033]" }, {
                  default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                    _createTextVNode(" Generate Monthly Progress Report ", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_unref(DialogDescription), { class: "text-[#6e7b92]" }, {
                  default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                    _createTextVNode(" Confirm the filters, choose optional supporting resources, and open the HTML report or download the matching PDF. ", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _createElementVNode("form", {
            class: "space-y-5 px-6 py-5",
            onSubmit: _withModifiers(submit, ["prevent"])
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _cache[12] || (_cache[12] = _createElementVNode("p", { class: "text-[0.75rem] font-extrabold uppercase tracking-[0.08em] text-[#748197]" }, " Client ", -1)),
                (canFilterByClient.value)
                  ? _withDirectives((_openBlock(), _createElementBlock("select", {
                      key: 0,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.client_id) = $event)),
                      class: "h-11 w-full rounded-[0.95rem] border border-[rgba(211,220,233,1)] bg-white px-3 text-sm text-[#243049] focus:border-[#8eb4ff] focus:outline-none focus:ring-2 focus:ring-[#cfe0ff]"
                    }, [
                      _cache[11] || (_cache[11] = _createElementVNode("option", { value: "all" }, " All Clients ", -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.clients, (client) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: client.id,
                          value: client.client_id
                        }, _toDisplayString(client.company_name), 9, _hoisted_4))
                      }), 128))
                    ], 512)), [
                      [_vModelSelect, form.client_id]
                    ])
                  : (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(currentClientLabel.value), 1))
              ]),
              _createElementVNode("div", _hoisted_6, [
                _cache[14] || (_cache[14] = _createElementVNode("p", { class: "text-[0.75rem] font-extrabold uppercase tracking-[0.08em] text-[#748197]" }, " Package ", -1)),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((packageValue).value = $event)),
                  class: "h-11 w-full rounded-[0.95rem] border border-[rgba(211,220,233,1)] bg-white px-3 text-sm text-[#243049] focus:border-[#8eb4ff] focus:outline-none focus:ring-2 focus:ring-[#cfe0ff]"
                }, [
                  _cache[13] || (_cache[13] = _createElementVNode("option", { value: "" }, " All Packages ", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.packageOptions, (pkg) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: pkg.value,
                      value: pkg.value
                    }, _toDisplayString(pkg.label), 9, _hoisted_7))
                  }), 128))
                ], 512), [
                  [_vModelSelect, packageValue.value]
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _cache[16] || (_cache[16] = _createElementVNode("p", { class: "text-[0.75rem] font-extrabold uppercase tracking-[0.08em] text-[#748197]" }, " Service ", -1)),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((serviceValue).value = $event)),
                  class: "h-11 w-full rounded-[0.95rem] border border-[rgba(211,220,233,1)] bg-white px-3 text-sm text-[#243049] focus:border-[#8eb4ff] focus:outline-none focus:ring-2 focus:ring-[#cfe0ff]"
                }, [
                  _cache[15] || (_cache[15] = _createElementVNode("option", { value: "" }, " All Services ", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.serviceOptions, (service) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: service.value,
                      value: service.value
                    }, _toDisplayString(service.label), 9, _hoisted_9))
                  }), 128))
                ], 512), [
                  [_vModelSelect, serviceValue.value]
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _cache[17] || (_cache[17] = _createElementVNode("p", { class: "text-[0.75rem] font-extrabold uppercase tracking-[0.08em] text-[#748197]" }, " Date From ", -1)),
                _createVNode(_unref(Input), {
                  modelValue: form.date_from,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.date_from) = $event)),
                  type: "date",
                  class: "h-11 rounded-[0.95rem] border-[rgba(211,220,233,1)] bg-white text-sm text-[#243049] focus-visible:ring-[#8eb4ff] focus-visible:ring-offset-0"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _cache[18] || (_cache[18] = _createElementVNode("p", { class: "text-[0.75rem] font-extrabold uppercase tracking-[0.08em] text-[#748197]" }, " Date To ", -1)),
                _createVNode(_unref(Input), {
                  modelValue: form.date_to,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.date_to) = $event)),
                  type: "date",
                  class: "h-11 rounded-[0.95rem] border-[rgba(211,220,233,1)] bg-white text-sm text-[#243049] focus-visible:ring-[#8eb4ff] focus-visible:ring-offset-0"
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _cache[20] || (_cache[20] = _createElementVNode("div", null, [
                  _createElementVNode("p", { class: "text-[0.88rem] font-extrabold text-[#182033]" }, " Supporting Resources "),
                  _createElementVNode("p", { class: "mt-1 text-[0.9rem] leading-6 text-[#6e7b92]" }, " Optional PDFs or images that can be referenced in the appendix. ")
                ], -1)),
                _createElementVNode("label", _hoisted_14, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.include_appendix) = $event)),
                    type: "checkbox",
                    class: "h-4 w-4 rounded border-[#c1cfe1] text-[#2f6fab] focus:ring-[#8eb4ff]"
                  }, null, 512), [
                    [_vModelCheckbox, form.include_appendix]
                  ]),
                  _cache[19] || (_cache[19] = _createTextVNode(" Include appendix ", -1))
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("input", {
                  type: "file",
                  multiple: "",
                  accept: ".pdf,.png,.jpg,.jpeg,.webp",
                  class: "block w-full cursor-pointer rounded-[0.95rem] border border-dashed border-[#c3d2e7] bg-white px-3 py-3 text-sm text-[#243049] file:mr-4 file:rounded-full file:border-0 file:bg-[#eaf2fb] file:px-4 file:py-2 file:text-sm file:font-bold file:text-[#2f6fab] hover:file:bg-[#ddeaf8]",
                  onChange: handleFiles
                }, null, 32),
                _cache[21] || (_cache[21] = _createElementVNode("p", { class: "mt-2 text-xs text-[#6e7b92]" }, " Allowed types: PDF, PNG, JPG, JPEG, WEBP. ", -1)),
                (selectedFiles.value.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedFiles.value, (file) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: `${file.name}-${file.size}`,
                          class: "flex items-center justify-between gap-3 rounded-[0.9rem] border border-[rgba(216,228,240,0.95)] bg-white px-3 py-2 text-sm"
                        }, [
                          _createElementVNode("span", _hoisted_17, _toDisplayString(file.name), 1),
                          _createElementVNode("span", _hoisted_18, _toDisplayString(formatSize(file.size)), 1)
                        ]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_19, " No supporting resources uploaded. "))
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _cache[22] || (_cache[22] = _createElementVNode("p", { class: "text-[0.72rem] font-extrabold uppercase tracking-[0.08em] text-[#748197]" }, " Client Scope ", -1)),
                _createElementVNode("p", _hoisted_22, _toDisplayString(summaryClient.value), 1)
              ]),
              _createElementVNode("div", _hoisted_23, [
                _cache[23] || (_cache[23] = _createElementVNode("p", { class: "text-[0.72rem] font-extrabold uppercase tracking-[0.08em] text-[#748197]" }, " Reporting Period ", -1)),
                _createElementVNode("p", _hoisted_24, _toDisplayString(summaryRange.value), 1)
              ]),
              _createElementVNode("div", _hoisted_25, [
                _cache[24] || (_cache[24] = _createElementVNode("p", { class: "text-[0.72rem] font-extrabold uppercase tracking-[0.08em] text-[#748197]" }, " Appendix ", -1)),
                _createElementVNode("p", _hoisted_26, _toDisplayString(form.include_appendix ? "Included" : "Disabled"), 1)
              ])
            ]),
            (__props.error)
              ? (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString(__props.error), 1))
              : _createCommentVNode("", true),
            _createVNode(_unref(DialogFooter), { class: "border-t border-[rgba(227,233,243,0.95)] px-0 pt-4" }, {
              default: _withCtx(() => [
                _createVNode(_unref(Button), {
                  variant: "outline",
                  type: "button",
                  class: "rounded-[0.95rem] border-[rgba(49,125,255,0.22)] bg-[#f6f9ff] px-4 py-2 font-bold text-[#2855a6] hover:bg-[#eef4ff]",
                  onClick: close
                }, {
                  default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                    _createTextVNode(" Cancel ", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_unref(Button), {
                  type: "submit",
                  class: "rounded-[0.95rem] bg-[#1f7aff] px-4 py-2 font-bold text-white hover:bg-[#1f7aff]",
                  disabled: __props.loading,
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (mode.value = 'html'))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(__props.loading && mode.value === 'html' ? "Generating..." : "Generate HTML Report"), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                _createVNode(_unref(Button), {
                  type: "submit",
                  class: "rounded-[0.95rem] bg-[#173b5f] px-4 py-2 font-bold text-white hover:bg-[#173b5f]",
                  disabled: __props.loading,
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (mode.value = 'pdf'))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(__props.loading && mode.value === 'pdf' ? "Generating..." : "Generate & Download Report"), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ]),
              _: 1
            })
          ], 32)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["open"]))
}
}

})